module.exports = __webpack_public_path__ + "img/dinersclub.2d6a9f05.png";